export function prepareForBackend(view) {
  var _view$private;
  return Object.assign({}, view, {
    private: (_view$private = view.private) !== null && _view$private !== void 0 ? _view$private : false
  });
}